import Vue from 'vue'
import axios from 'axios'
import configuration from '@/config'
import { getUserToken } from '@/utils/localStorage'

const axiosLineDiyServiceInstance = axios.create({
  baseURL: configuration.LINE_DIY_API_URL
})

axiosLineDiyServiceInstance.interceptors.request.use((config) => {
  if (!config.headers.common.Authorization) {
    // eslint-disable-next-line no-param-reassign
    config.headers.common.Authorization = `Bearer ${getUserToken()}`
  }

  return config
}, (error) => Promise.reject(error))

axiosLineDiyServiceInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if ([401, 403].includes(error.response?.status)) {
      if (Vue.prototype.$liff.isInClient()) {
        Vue.prototype.$liff.closeWindow()
      } else {
        Vue.prototype.$auth.logout()
      }
    }

    return Promise.reject(error)
  }
)

class LineDiyHttpRequest {
  constructor () {
    this.axiosInstance = axiosLineDiyServiceInstance
  }
}

export default LineDiyHttpRequest
